import { cn } from '@rental/ui'
import type { ReactNode } from 'react'

/**
 * A screen's views (Report's Ricavi and Aperti, Multe's open ones and all),
 * each a link to its address, so Back and a link shared keep the view. Drawn
 * as `ChoiceChips` are, one of a few chosen: the current view's chip in logo
 * blue, its words bold, and named as the current page (`aria-current`).
 */
export function TabLinks({ label, children }: { label: string; children: ReactNode }) {
  return (
    <nav aria-label={label} className="flex flex-wrap gap-2">
      {children}
    </nav>
  )
}

/**
 * A view's link: pass `aria-current="page"` on the current one, this, and
 * `activeOptions={{ exact: true }}`. The router marks an active link current
 * itself, over the screen's own mark, and by default a part of the address is
 * enough: the view with no parameter would be current on every other view.
 */
export function tabClass(current: boolean) {
  return cn(
    'flex min-h-touch items-center rounded-sm border px-4 no-underline',
    current ? 'border-brand bg-surface font-bold text-brand' : 'border-text-muted text-text',
  )
}
